module.exports = __webpack_public_path__ + "img/11_36.1d307731.png";